<h2 class="mb-6 py-4">Your quote</h2>
<h3 *ngIf="!hideSubtitle">Your {{ isInsurance ? 'cover' : 'plan' }}</h3>
